var map = {
	"./01-img.png": 8736,
	"./02-img.png": 8308,
	"./03-img.png": 7793,
	"./04-img.png": 7637,
	"./05-img.png": 2378,
	"./06-img.png": 6387,
	"./07-img.png": 5934,
	"./08-img.png": 4006,
	"./09-img.png": 2479,
	"./10-img.png": 5342,
	"./11-img.png": 377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4551;